import React, { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { Loader2, Search } from 'lucide-react';
import { useAdminEntitlements } from '@/hooks/useAdminCatalog';

export default function AdminEntitlements() {
  const { data, isLoading } = useAdminEntitlements();
  const [q, setQ] = useState('');

  if (isLoading) {
    return <div className="flex justify-center py-12"><Loader2 className="h-6 w-6 animate-spin text-zinc-400" /></div>;
  }
  if (!data) return null;

  const filtered = data.filter((e) => {
    if (!q) return true;
    const s = q.toLowerCase();
    return (
      e.organization_name.toLowerCase().includes(s) ||
      e.addon_slug.toLowerCase().includes(s) ||
      e.addon_name.toLowerCase().includes(s) ||
      (e.lemonsqueezy_order_id ?? '').toLowerCase().includes(s)
    );
  });

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-bold text-zinc-900">Entitlements</h1>
        <p className="text-sm text-zinc-500">Chi ha comprato cosa. Filtra per org, addon o order ID.</p>
      </div>

      <div className="relative max-w-md">
        <Search className="absolute left-3 top-2.5 h-4 w-4 text-zinc-400" />
        <Input
          placeholder="Cerca organizzazione, addon, order ID…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          className="pl-9"
        />
      </div>

      <Card>
        <CardContent className="p-0">
          <div className="overflow-auto max-h-[600px]">
            <table className="w-full text-sm">
              <thead className="bg-zinc-50 text-xs text-zinc-500 uppercase tracking-wider sticky top-0">
                <tr>
                  <th className="text-left px-3 py-2">Organizzazione</th>
                  <th className="text-left px-3 py-2">Prodotto</th>
                  <th className="text-left px-3 py-2">Data acquisto</th>
                  <th className="text-left px-3 py-2">Order LS</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-zinc-100">
                {filtered.map((e) => (
                  <tr key={e.id} className="hover:bg-zinc-50">
                    <td className="px-3 py-2 font-medium text-zinc-900">{e.organization_name}</td>
                    <td className="px-3 py-2">
                      <div className="font-medium text-zinc-800">{e.addon_name}</div>
                      <div className="font-mono text-[10px] text-zinc-500">{e.addon_slug}</div>
                    </td>
                    <td className="px-3 py-2 text-zinc-600 text-xs">
                      {new Date(e.purchased_at).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                    </td>
                    <td className="px-3 py-2">
                      {e.lemonsqueezy_order_id ? (
                        <Badge variant="outline" className="font-mono text-[10px] bg-emerald-50 text-emerald-700 border-emerald-200">
                          #{e.lemonsqueezy_order_id}
                        </Badge>
                      ) : (
                        <Badge variant="outline" className="text-[10px] bg-zinc-50 text-zinc-500 border-zinc-200">manuale</Badge>
                      )}
                    </td>
                  </tr>
                ))}
                {filtered.length === 0 && (
                  <tr><td colSpan={4} className="px-3 py-8 text-center text-zinc-400 text-sm">Nessun entitlement trovato.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
